import React from "react";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import AppTheme from "../../../../service/app_config/AppTheme";
import { useDispatch } from "react-redux";
import { addModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";
import { ChatsContextImport } from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import ConversationActions from "../../widget/chat_conversation/ConversationActions";

const ChatActions = () => {
  const dispatch = useDispatch();

  const { chatSelected } = ChatsContextImport();

  const onClickMenu = () => {
    dispatch(
      addModal({ id: ModalKeys.work_profile_menu, title: "work_profile" })
    );
  };

  return (
    <>
      {chatSelected ? (
        <ConversationActions />
      ) : (
        <IconNormal
          name="more"
          color={AppTheme.themeFont}
          handleClick={onClickMenu}
        />
      )}
    </>
  );
};

export default ChatActions;
